import useTranslation from 'shared/hooks/useTranslation';
import styled from 'styled-components';
import { ButtonWrapper } from 'shared/components/Styled';
import COMPANY_DATA from 'config/companyData';
import SocialIconLink from 'shared/components/SocialIconLinkV2';
import { DesktopBlur, MobileBlur, Wrapper } from './styled';
import BlurElement from './BlurElement';

function SocialMedia(): JSX.Element {
  const { t } = useTranslation('ourTeamPage');

  return (
    <Wrapper maxWidth>
      <DesktopBlur>
        <BlurElement speed={0.1} size={500} position={{ x: 0, y: -400 }} />
        <BlurElement speed={0.1} size={500} direction="right" position={{ x: 0, y: -700 }} />
      </DesktopBlur>
      <MobileBlur>
        <BlurElement speed={0.2} size={300} direction="right" position={{ x: 0, y: -2500 }} />
      </MobileBlur>
      <Header>{t('followUs')}</Header>
      <ButtonWrapper columns="3" justifyContent="center">
        <SocialIconLink
          href={COMPANY_DATA.FACEBOOK}
          src="/img/social-icons/facebook.svg"
          alt="Facebook logo"
          width={25}
          height={25}
          isTarget
        />
        <SocialIconLink
          href={COMPANY_DATA.LINKEDIN}
          src="/img/social-icons/linked.svg"
          alt="LinkedIn logo"
          width={25}
          height={25}
          isTarget
        />
        <SocialIconLink
          href={COMPANY_DATA.INSTAGRAM}
          src="/img/social-icons/instagram.svg"
          alt="Instagram logo"
          width={25}
          height={25}
          isTarget
        />
      </ButtonWrapper>
    </Wrapper>
  );
}

const Header = styled.h4`
  color: #fff;
  text-align: center;
  font-size: 2rem;
  line-height: 150%;
  letter-spacing: 1.109px;
  margin-bottom: 6rem;

  @media ${({ theme }) => theme.DEVICE.MD} {
    font-size: 4.2rem;
    line-height: 121%;
  }
`;

export default SocialMedia;
